import React, { useContext } from "react";
import { MapPin, Lock } from "lucide-react";
import { GROEPEN, groepVan, relLabel, cpVoortgang, isGemeld, compareRows, isIntern, internLabel } from "./afsprakenUtils";
import { OpvolgerLabel } from "./Opvolger";
import { GemeldPill, KlaarLabel } from "./AfspraakRow";
import { ReactieTeller } from "./Reacties";
import { SnippetContext } from "./reactieUtils";

const BoardCard = ({ a, onSelect }) => {
  const { done, total } = cpVoortgang(a);
  const snippet = useContext(SnippetContext)[a.id];
  return (
    <button type="button" data-testid={`board-card-${a.id}`} onClick={() => onSelect(a)}
      className="w-full text-left bg-white rounded-[10px] border border-zinc-200 p-3 space-y-2 hover:border-zinc-400 hover:-translate-y-px transition-[transform,border-color] duration-150">
      <p data-testid={`board-wat-${a.id}`} className="text-sm font-semibold text-zinc-900 whitespace-pre-line break-words">{a.wat}</p>
      {a.vervolgOp && <span data-testid={`board-vervolgtag-${a.id}`} className="inline-block text-[10px] font-bold uppercase tracking-wider text-blue-700">Vervolg</span>}
      {a.bron === "locatie" && <span data-testid={`board-door-locatie-${a.id}`} className={`inline-block text-[10px] font-bold uppercase tracking-wider text-amber-700 ${a.vervolgOp ? "ml-2" : ""}`}>door de locatie</span>}
      {isIntern(a) ? <p className="flex items-center gap-1 text-xs text-zinc-500"><Lock className="h-3.5 w-3.5 shrink-0" />{internLabel(a)}</p>
        : a.locatie && <p className="flex items-center gap-1 text-xs text-zinc-500"><MapPin className="h-3.5 w-3.5" />{a.locatie}</p>}
      {snippet && <p data-testid={`board-snippet-${a.id}`} className="text-xs text-zinc-500 break-words">Reactie: {snippet}</p>}
      <div className="flex items-center justify-between gap-2">
        <OpvolgerLabel a={a} testid={`board-opvolger-${a.id}`} />
        <span className="flex items-center gap-2 shrink-0">
          <ReactieTeller n={(a.reacties || []).length} testid={`board-reacties-${a.id}`} />
          {a.klaarOmAfTeRonden ? <KlaarLabel testid={`board-klaar-${a.id}`} /> : <span className={`font-mono text-xs ${a.overdue ? "text-rose-600 font-bold" : "text-zinc-500"}`}>{relLabel(a)}</span>}
        </span>
      </div>
      {total > 0 && (
        <div>
          <div className="h-1 rounded-full bg-zinc-100 overflow-hidden"><div className="h-full bg-blue-600" style={{ width: `${(done / total) * 100}%` }} /></div>
          <div className="flex items-center justify-between mt-1">
            <span className="font-mono text-[11px] text-zinc-500">{done}/{total} peilmomenten</span>
            {isGemeld(a) && <GemeldPill />}
          </div>
        </div>
      )}
    </button>
  );
};

export const AfspraakBoard = ({ items, sortBy, onSelect }) => {
  const per = Object.fromEntries(GROEPEN.map((g) => [g.key, []]));
  for (const a of items) per[groepVan(a)].push(a);
  return (
    <div data-testid="afspraken-bord" className="grid grid-cols-1 md:grid-cols-2 min-[1100px]:grid-cols-4 gap-4 items-start">
      {GROEPEN.map((g) => (
        <section key={g.key} data-testid={`bord-kolom-${g.key}`} className="rounded-[10px] overflow-hidden border border-zinc-200">
          <header className={`bg-zinc-950 text-white rounded-t-[10px] border-t-4 ${g.top} px-3 py-2 flex items-center justify-between`}>
            <span className="font-heading font-black uppercase text-xs tracking-wider">{g.label}</span>
            <span className="font-mono text-xs" data-testid={`bord-kolom-count-${g.key}`}>{per[g.key].length}</span>
          </header>
          <div className="p-2 space-y-2 bg-zinc-50 min-h-[80px]">
            {per[g.key].length === 0 ? <p className="text-xs text-zinc-400 text-center py-4">Niets</p>
              : [...per[g.key]].sort(compareRows(sortBy)).map((a) => <BoardCard key={a.id} a={a} onSelect={onSelect} />)}
          </div>
        </section>
      ))}
    </div>
  );
};
